
const digest = '55a10060f47ad2ad6ff906f88439fca109c707523ad9157f4815f9ee8a7fc1a5';
const classes = {"exportWrapper":"_exportWrapper_1ub7o_1"};
const css = `._exportWrapper_1ub7o_1 {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin: 20px 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  